import React from 'react';
import { toast } from 'react-toastify';
import Select from '../../../components/Common/Input/Select';
import Error from '../../../components/Error';
import Modal from '../../../components/Modal';
import message from '../../../constant/message';
import LenderUgroService from '../../../services/lender';

export default function OpsModal({
	toggleModal,
	leadId,
	userType,
	state,
	reloadTable,
	actionType,
}) {
	let inputRef = React.useRef(null);
	const [file, setFile] = React.useState(null);
	const [comment, setComment] = React.useState('');
	const [loading, setLoading] = React.useState(false);
	const [type, setOpsModalActionType] = React.useState(actionType || 'approve');
	const [rejectType, setRejectType] = React.useState(null);
	const [rejectOptions] = React.useState([
		{ label: 'Business Vintage', value: '1' },
		{ label: 'CIBIL,DPD & DSCR', value: '2' },
		{ label: 'Eligibility Method', value: '3' },
		{ label: 'Technical', value: '4' },
		{ label: 'Legal', value: '5' },
		{ label: 'LTV', value: '6' },
		{ label: 'Property', value: '7' },
	]);
	const [errors, setErrors] = React.useState(null);
	const formSubmitHandler = async (e) => {
		e.preventDefault();
		setLoading(true);

		await modifyLeadOpsStatus();
		reloadTable && reloadTable();
		setLoading(false);
	};

	const modifyLeadOpsStatus = async () => {
		try {
			const formData = new FormData();
			type && formData.append('type', type);
			leadId && formData.append('lead_id', leadId);
			file && formData.append('file', file);
			comment && formData.append('comment', comment);
			rejectType && formData.append('reject_type', rejectType?.value);
			const response = await LenderUgroService.modifyLeadOpsStatus(
				userType,
				formData
			);
			handleSuccessResponse(response);
		} catch (err) {
			console.log(err);
			handleErrorResponse(err);
		}
	};

	const handleSuccessResponse = (response) => {
		if (response?.data?.status?.code === 1) {
			const success = response?.data?.messages?.success;
			toast.success(
				success?.form?.[0] || success?.others?.[0] || message.SAVED_SUCCESS
			);
			// inputRef.current.value = '';
			toggleModal(true);
		}
	};
	const handleErrorResponse = (err) => {
		let error = err?.response?.data?.messages?.error;
		toast.error(error?.form?.[0] || error?.others?.[0] || message.ERROR_FORM);
		setErrors(error);
	};
	return (
		<Modal state={state} closeModal={toggleModal}>
			<p><b>
				{type === 'approve' && window.location.pathname.indexOf("portfolio/view") !== -1 && 'Are you sure you want to disburse this lead?'}
				{type === 'reject' && window.location.pathname.indexOf("portfolio/view") !== -1 && 'Are you sure you want to reject this lead?'}
			</b></p>
			<form onSubmit={formSubmitHandler}>
				{!actionType && (
					<div className=' form-group'>
						<div className='row no-gutters'>
							<div
								class='custom-control custom-radio'
								onClick={(e) => setOpsModalActionType('approve')}
							>
								<input
									type='radio'
									class='custom-control-input'
									name='leadStatus'
									value={1}
									id={1}
									checked={type === 'approve'}
								/>
								<label class='custom-control-label mt-1' for='defaultUnchecked'>
									Disburse
								</label>
							</div>
							<div
								class='custom-control custom-radio ml-2'
								onClick={(e) => setOpsModalActionType('reject')}
							>
								<input
									type='radio'
									class='custom-control-input'
									name='leadStatus'
									value={1}
									id={1}
									checked={type === 'reject'}
								/>
								<label class='custom-control-label mt-1' for='defaultUnchecked'>
									Reject
								</label>
							</div>
						</div>
					</div>
				)}
				{type === 'reject' && (
					<>
						<div class='form-group'>
							<Select
								label={'Reason for Rejection'}
								isMulti={false}
								isClearable
								onChange={(value) => setRejectType(value)}
								options={rejectOptions}
								value={rejectType}
							/>
						</div>
						<div class='form-group'>
							<label>Upload File</label>
							<div class='row'>
								<div class='col-12'>
									<input
										ref={inputRef}
										file={file}
										onChange={(e) => setFile(e.target.files[0])}
										type='file'
										className='form-control'
									/>
								</div>
							</div>
							<Error errors={errors} id='file' />
						</div>
					</>
				)}

				<div class='form-group'>
					<label>Comment</label>
					<textarea
						class='form-control custom-form-control'
						cols='4'
						rows='4'
						value={comment}
						onChange={(e) => setComment(e.target.value)}
						maxLength = "240"
					></textarea>
					<Error errors={errors} id='comment' />
				</div>
				<div class='d-flex align-items-center'>
					<button type='submit' class='btn btn-custom' disabled={loading}>
						{loading ? <div className='loader' /> : 'OK'}
					</button>
					<button
						type='button'
						class='btn btn-outline-custom ml-2'
						data-dismiss='modal'
						onClick={toggleModal}
					>
						Cancel
					</button>
				</div>
			</form>
		</Modal>
	);
}
